var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.7638 7.99995L5.15948 1.86595C4.95695 1.67795 4.94592 1.36095\n  5.13441 1.15895C5.32291 0.957949 5.64074 0.945949 5.84327 1.13395L12.8406 7.63395C12.9429 7.72895 13 7.86095 13\n  7.99995C13 8.13895 12.9429 8.27095 12.8406 8.36595L5.84327 14.8689C5.74601 14.9589 5.62369 15.0029 5.50137\n  15.0029C5.36702 15.0029 5.23267 14.9499 5.13441 14.8439C4.94592 14.642 4.95695 14.3259 5.15948 14.1379L11.7638\n  7.99995Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
